<template>
    <v-layout row wrap>
        <v-flex xs4 offset-xs4>
            <v-card>
                <v-card-text>
                    <v-form ref="form" @submit.prevent="submit">
                        <div class="title mb-3 mt-1">GDS &mdash; Gestão de Demandas e Serviços</div>

                        <label class="form-label text-xs-left">{{ $t("label.user") }}</label>
                        <v-text-field v-model="form.username" :rules="validation.login" :validate-on-blur="true"></v-text-field>

                        <label class="form-label text-xs-left">{{ $t("label.currentPassword") }}</label>
                        <v-text-field type="password" v-model="form.oldPassword" :rules="validation.password" :validate-on-blur="true"></v-text-field>

                        <label class="form-label text-xs-left">{{ $t("label.newPassword") }}</label>
                        <v-text-field type="password" v-model="form.newPassword" :rules="validation.password" :validate-on-blur="true"></v-text-field>

                        <label class="form-label text-xs-left">{{ $t("label.confirmPassword") }}</label>
                        <v-text-field type="password" v-model="form.confirmPassword" :rules="rules.confirmPassword" :validate-on-blur="true"></v-text-field>

                        <v-btn type="submit" color="primary" class="ml-0" :loading="loading">{{ $t("label.enter") }}</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<style lang="stylus">
</style>

<script>
import validation from '@/helpers/validation';

export default {
    data() {
        return {
            validation,
            loading: false,
            form: {
                username: '',
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },

            rules: {
                confirmPassword: [
                    ...validation.required,
                    () => this.form.newPassword === this.form.confirmPassword || this.$t('message.error.passwordNoMatch'),
                ],
            },
        };
    },
    methods: {
        async submit() {
            if (!this.$refs.form.validate()) return;

            try {
                this.loading = true;
                await this.$store.dispatch('changePassword', this.form);
                this.$router.push({ name: 'login' });
            } catch (e) {
                this.loading = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/login/ExpiredPassword.vue